import styled from "styled-components";
import { colors } from "styles/theme";

export const BlockFilterFormWrapper = styled.div`
  max-width: 450px;
  height: 100%;
  background-color: ${colors.lightBlack};

  .filter-form {
    width: 100%;
    padding: 20px;
  }
`;
